import axios from 'axios';
import { TEST_SERVER_URL } from '../constants/Common';


export default axios.create({
  baseURL: `http://${TEST_SERVER_URL}:3001/v2/`,//YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  }
});